import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { getLiteral } from 'utils/getLiteral';
import './style.scss';

class SyncSummary extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    render() {
        let { fieldsConfig, usersMatched, fieldsMatched } = this.props;
        let fieldsArr = Object.keys(fieldsConfig).map((entity) => {
            return getLiteral('label_' + entity + '_matched').replace('%@', fieldsMatched[entity]);
        });
        return (
            <div className="sync-summary">
                <div className="sync-summary-title">
                    <Literal literal={'label_integration_summary'} />
                </div>
                <div className="sync-summary-content">
                    <span>{getLiteral('label_users_matched').replace('%@', usersMatched)}</span>
                    <span>{getLiteral('label_fields_matched') + ': ' + fieldsArr.join(', ')}</span>
                </div>
            </div>
        );
    }
}

export default SyncSummary;
